export function readSpotPopupTabsFromSearchParams(searchParams) {
    return {
        initialTab: searchParams.get("tab") || "main",
        initialPhotoTab: searchParams.get("photo_tab") || "place",
        initialWeatherSubtab: searchParams.get("weather_subtab") || "bite",
    };
}

export function writeSpotPopupTabsToUrl(spotId, { activeTab, activePhotoTab, activeWeatherSubtab }) {
    if (!spotId || typeof window === "undefined") return;

    const params = new URLSearchParams(window.location.search);
    params.set("spot-id", String(spotId));

    if (!activeTab || activeTab === "main") {
        params.delete("tab");
        params.delete("photo_tab");
        params.delete("weather_subtab");
    } else {
        params.set("tab", activeTab);
        if (activeTab !== "photos") {
            params.delete("photo_tab");
        } else if (!activePhotoTab || activePhotoTab === "place") {
            params.delete("photo_tab");
        } else {
            params.set("photo_tab", activePhotoTab);
        }
        if (activeTab !== "weather") {
            params.delete("weather_subtab");
        } else if (!activeWeatherSubtab || activeWeatherSubtab === "bite") {
            params.delete("weather_subtab");
        } else {
            params.set("weather_subtab", activeWeatherSubtab);
        }
    }

    const query = params.toString();
    const nextUrl = query ? `${window.location.pathname}?${query}` : window.location.pathname;
    const currentUrl = `${window.location.pathname}${window.location.search}`;
    if (currentUrl !== nextUrl) {
        window.history.replaceState(window.history.state, "", nextUrl);
    }
}
